// Module
var code = "<div style=\"padding-bottom:0\"> <img ng-repeat=\"slide in slides\" ng-class=\"{active: slide.active}\" src=\"data:image/gif;base64,R0lGODlhAQABAIAAAAUEBAAAACwAAAAAAQABAAACAkQBADs=\" data-imgsrc=\"{{::slide.url}}\" class=\"slide-img z-10\"/> </div> ";
// Exports
var _module_exports =code;;
var path = '/codebuild/output/src2905724180/src/frontend/js/directives/public/nsCarousel.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;